import { render } from "./NewsAreaThree.vue?vue&type=template&id=5ec33b58"
import script from "./NewsAreaThree.vue?vue&type=script&lang=js"
export * from "./NewsAreaThree.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__